import React, { Component, Fragment } from 'react'
import BootstrapTable from "react-bootstrap-table-next"
import LoadingImage from '../../../comum/components/LoadingImage'

export default class TabelaNotaFiscalItemFaturamento extends Component {
    constructor(props) {
        super(props)
        this.state = { itens: [], notaId: this.props.notaId }
        this.controller = this.props.controller
    }

    componentDidMount() {
        if (this.state.notaId !== 0) {
            this.controller.getItens(this.state.notaId).then(itens => {
                this.setState({ itens: itens })
            })
        }
    }

    render() {
        const { colunasNotaFaturamentoItem: columns } = this.controller
        const { itens } = this.state
        return (
            <Fragment>
                {(itens && itens.length > 0) ?
                    (
                        <Fragment>
                            <BootstrapTable
                                bootstrap4
                                striped
                                condensed
                                hover
                                bordered={false}
                                keyField='Id'
                                data={[...itens]}
                                columns={[...columns]}
                            />
                        </Fragment>
                    )
                    : <LoadingImage />
                }
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/notafiscal/components/TabelaNotaFiscalItemFaturamento.js